import React, { useContext } from 'react';
import './partners.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import partners from '../../images/partners.svg';
import partnersAR from '../../images/partnersAR.svg';

// import axios from '../../api/DataTrans';
const Partners = () => {
    const {lang} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
  return (
    <div className='contact_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            // paddingTop:width < 1000 ? "100px":'0px',
            paddingBottom:width < 1000 ? "100px":'0px'
            }}>
        <div className='contact_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                     marginTop:width<1000 ?'50px':'0px',flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='contact_box_1'>
                {!lang && <img src={partners} style={{width:width<=1000 ? "80%" : "100%"}} alt=''/>}
                {lang && <img src={partnersAR} style={{width:width<=1000 ? "80%" : "100%"}} alt=''/>}
            </div>
        </div>
        <div className='contact_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='contact_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='contact_para'>{t("partners.we")}</p>
                <p className='contact_para'>{t("partners.we1")}</p>
            </div>
            <div className='contact_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='contact_para'>{t("partners.achiv")}</p>
                <p className='contact_para'>{t("partners.achiv1")}</p>
            </div>
                {/* <div className='contact_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='contact_para' style={{color:"rgb(20,138,117)"}}>{t("contact.phone1")}</p>
                    <p className='contact_para' style={{color:"rgb(35,56,98)",marginTop:'5px',marginRight:lang?'25px':'0px',marginLeft:!lang?'25px':'0px'}}>{t("contact.damascus")}</p>
                    <p className='contact_para' style={{marginRight:lang?'50px':'0px',marginLeft:!lang?'50px':'0px'}}>011 678-678-6</p>
                </div>
                <div className='contact_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='contact_para' style={{color:"rgb(20,138,117)"}}>{t("employment.phone")}</p>
                    <p className='contact_para'>+963 963-963-963</p>
                </div>
                <div className='contact_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='contact_para' style={{color:"rgb(20,138,117)"}}>{t("contact.email")}</p>
                    <p className='contact_para'>www.waygo@gmail.com</p>
                </div> */}
        </div>
    </div>
  )
}

export default Partners